import { EmptyListMessageController } from './empty-list-message.controller'

const component = {
  templateUrl: '/core/components/empty-list-message/empty-list-message.html?$$REVISION$$',
  bindings: {
    icon: '@',
    message: '@',
    suggestion: '@',
    stateTo: '@',
    buttonText: '@'
  },
  controllerAs: '$ctrl',
  controller: EmptyListMessageController
}

export const emptyListMessage = component
